import React from 'react';
import {Route, Routes} from 'react-router-dom';

import {CreateRole} from './modules/create-role';
import {RoleProfile} from './modules/role-profile';
import {RolesPage} from './modules/roles-page';

export const RolesRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<RolesPage/>}/>
            <Route path="/create" element={<CreateRole/>}/>
            <Route path="/:roleId/*" element={<RoleProfile/>}/>
        </Routes>
    );
};
